import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';

/** Keep bookmarked Classic deal URLs on the new Advances screen. */
export const redirectLegacyDeal: RedirectFunction = ({
  queryParams,
  fragment,
}) => {
  const { id, ...remaining } = queryParams;
  const validId =
    typeof id === 'string' &&
    /^[1-9]\d*$/.test(id) &&
    Number.isSafeInteger(Number(id));
  return inject(Router).createUrlTree(['/advance'], {
    queryParams: { ...remaining, ...(validId ? { deal: id } : {}) },
    fragment: fragment ?? undefined,
  });
};
